export const ROUTE_PATH = '/stores';
